import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectLoadMessageOnSignOnOption')(function selectLoadMessageOnSignOnOption(loadMessage, state) {
    var optionState = state.optionState;
    optionState.loadMessageOnLogOn = loadMessage;
}));
//# sourceMappingURL=selectLoadMessageOnSignOnOption.js.map